/* eslint-disable */
import moment from 'moment'
import backboneModelDeepInstanceOf from "@/js/common/Domain/Service/backboneModelDeepInstanceOf";

export default function getPropertyForTourClick({tour, hotelId} = {}) {
	if (!backboneModelDeepInstanceOf({model: tour})) {
		return false
	}
	return {
		cityFrom: backboneModelDeepInstanceOf({
			model: tour,
			values: ['departureCity']
		}) ? tour.get("departureCity").get('id') : null,
		countryTo: backboneModelDeepInstanceOf({
			model: tour,
			values: ["resort", "country"]
		}) ? tour.get("resort").get("country").get('id') : null,
		hid: hotelId || null,
		price: tour.get("price") || null,
		taxoil: tour.get("oilTaxIsAbsent") ? 999999 : tour.get("oilTax"),
		nights: tour.get("nights") || null,
		date: moment(tour.get("checkInDate"), "YYYY-MM-DD").format("DD-MM-YYYY"),
		operator: tour.get("operator") ? tour.get("operator").name : null,
		room: tour.get("room") ? tour.get("room").name : null,
		adults: tour.get("touristGroup") ? tour.get("touristGroup").adults : null,
		kids: tour.get("touristGroup") ? tour.get("touristGroup").kids : null,
		infants: tour.get("touristGroup") ? tour.get("touristGroup").infants : null
	};
}